import tabNavigation from 'foundation/js/utils/tabNavigation'
import { useSearchStore } from 'stores/search.store'
import { useMenuStore } from 'stores/menu.store'
import { computed, onMounted, ref, watch } from 'vue'
import debounce from 'foundation/js/debounce'

export default {
    name: 'MenuSearch',
    props: {
        guid: {
            type: String,
            required: true,
        },
        suggestions: {
            type: Array,
            default: () => [],
            required: true,
        },
        redirecturl: {
            type: String,
            default: '',
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const menuStore = useMenuStore()
        const searchStore = useSearchStore()
        const activeMenu = computed(() => menuStore.activeMenu)
        const searchValue = ref('')
        const searchNavRef = ref(null)
        const searchInputRef = ref(null)
        const mobileSearchLinkRef = ref(null)
        const suggestionsClassname = ref('')

        const autoCompleteResults = computed(() => {
            if (searchValue.value === '') {
                return []
            } 
            suggestionsClassname.value = ''
            return searchStore.results["searchBar"] ?? []
        })

        onMounted(() => {
            searchStore.setSearchUrl({ 
                guid: props.guid, 
                searchKey: "searchBar",
                url: process.env.SEARCH_AUTOCOMPLETE.replace('[guid]', props.guid) 
            })
            searchStore.setTakeSize({ guid: props.guid, searchKey: "searchBar", take: 10 })
            searchStore.setCurrentPage({ searchKey: "searchBar", })
        })

        watch(searchValue, (newValue) => {
            
            debounce(() => {
                searchStore.setSearchQuery({ guid: props.guid, searchKey: "searchBar", query: newValue })
                searchStore.performSearch({ guid: props.guid, searchKey: "searchBar", replaceResults: true, take: 10 })
            }, 300)()  
            suggestionsClassname.value = newValue !== '' ? 'be-menu-search__content-suggestions--hide' : ''
        })

        const isActiveAction = computed(() => {
            const show = activeMenu.value === 'search'
            if (show) {
                setTimeout(() => {
                    if (searchInputRef.value) {
                        searchInputRef.value?.focus()
                    }
                    if (mobileSearchLinkRef.value) {
                        mobileSearchLinkRef.value?.focus()
                    }
                }, 50)
            }

            return show
        })

        const handleSearch = function () {
            window.location.href = `${props.redirecturl}?q=${searchValue.value}`
        }

        const handleKeyNavigation = function (e) {
            const tabProps = {
                parentContainer: searchNavRef.value,
                targetClassName: 'be-js--menu-search-item',
                key: e.key,
            }
            const tabTraps = new tabNavigation(tabProps)
            
            switch (e.key) {
                case 'Tab':
                    e.preventDefault()
                    if (e.shiftKey) {
                        tabTraps.tabTrapPrev()
                    } else {
                        tabTraps.tabTrapNext()
                    }
                    break
                case 'ArrowDown':
                case 'ArrowRight':
                    e.preventDefault()
                    tabTraps.tabTrapNext()
                    break
                case 'ArrowUp':
                case 'ArrowLeft':
                    e.preventDefault()
                    tabTraps.tabTrapPrev()
                    break
                default:
                    break
            }
        }

        return {
            isActiveAction,
            searchValue,
            searchNavRef,
            searchInputRef,
            mobileSearchLinkRef,
            suggestionsClassname,
            autoCompleteResults,
            handleSearch,
            handleKeyNavigation,
        }
    },
}
